import { svgIconClasses, Theme, typographyClasses } from '@mui/material';
import {
  dayCalendarClasses,
  pickersOutlinedInputClasses,
} from '@mui/x-date-pickers-pro';

import { themeBase } from '../theme-base';

const { spacing, palette } = themeBase;
export const muiDateRangePicker: Theme['components'] = {
  MuiPickerPopper: {
    styleOverrides: {
      paper: {
        marginTop: spacing(0.5),
      },
    },
  },
  MuiPickersTextField: {
    styleOverrides: {
      root: {
        '& .MuiInputBase-root': {
          color: palette.grey[200],
        },
        '& .MuiInput-underline:before': {
          borderBottomColor: palette.grey[600],
        },
        '& .MuiInput-underline:hover:before': {
          borderBottomColor: palette.grey[400],
        },
        '& .MuiInput-underline:after': {
          borderBottomColor: palette.mapBlue[300],
        },
      },
    },
  },
  MuiPickersInputBase: {
    styleOverrides: {
      root: {
        lineHeight: '1.4375em',
        boxSizing: 'border-box',
        cursor: 'text',
        display: 'inline-flex',
        webkitBoxAlign: 'center',
        borderRadius: '4px',
        backgroundColor: 'rgba(29, 42, 55, 0.5)',
        color: 'rgb(221, 221, 221)',
        padding: '8px 16px',
        gap: '16px',
      },
      input: {
        '&::placeholder': {
          color: palette.grey[500],
          opacity: 1,
        },
      },
    },
  },
  MuiPickersOutlinedInput: {
    styleOverrides: {
      root: {
        backgroundColor: `${palette.mapBlue[700]}80`,
        color: palette.grey[200],
        padding: spacing(1, 2),
        gap: spacing(2),
        [`.${svgIconClasses.root}`]: {
          fill: '#FFFFFF',
        },
        '&:hover': {
          [`.${pickersOutlinedInputClasses.notchedOutline}`]: {
            borderColor: '#33383F',
          },
        },
        '&.Mui-focused:not(.Mui-error)': {
          [`.${pickersOutlinedInputClasses.notchedOutline}`]: {
            borderColor: '#33383F',
          },
        },
      },
      sectionsContainer: {
        padding: 0,
        span: {
          lineHeight: '27px',
        },
      },
      notchedOutline: {
        borderWidth: 2,
        lineHeight: '27px',
        borderColor: palette.mapBlue[700],
        borderRadius: spacing(1.25),
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
      },
    },
  },
  MuiDayCalendar: {
    styleOverrides: {
      root: {
        [`.${dayCalendarClasses.weekDayLabel}`]: {
          color: palette.grey[200],
        },
      },
    },
  },
  MuiPickersToolbarText: {
    styleOverrides: {
      root: {
        ['&.Mui-selected']: {
          color: palette.mapBlue[300],
        },
      },
    },
  },
  MuiDateRangePickerDay: {
    styleOverrides: {
      root: {
        color: palette.grey[200],
      },
      day: {
        color: palette.grey[300],
        fontSize: '12px',
        ['&.Mui-selected']: {
          backgroundColor: palette.mapBlue[600],
          ['&:hover']: {
            backgroundColor: palette.mapBlue[500],
          },
        },
      },
      rangeIntervalDayHighlight: {
        background: palette.mapBlue[800],
      },
      hiddenDayFiller: {
        background: 'transparent',
      },
      rangeIntervalDayHighlightStart: {
        borderColor: palette.mapBlue[600],
      },
      rangeIntervalDayHighlightEnd: {
        borderColor: palette.mapBlue[600],
      },
    },
  },
  MuiPickersArrowSwitcher: {
    styleOverrides: {
      root: {
        [`.${svgIconClasses.root}`]: {
          color: palette.grey[400],
          height: 24,
          width: 24,
        },
      },
    },
  },
  MuiPickersToolbar: {
    styleOverrides: {
      root: {
        [`.${typographyClasses.root}`]: {
          color: palette.grey[100],
        },
      },
    },
  },
};
